import React, { useState } from 'react';
import { Input, Button, Typography } from 'antd';
import { UserOutlined, MailOutlined } from '@ant-design/icons';
import Swal from 'sweetalert2';
import axios from 'axios';
import './subscribebutton.css';

const { Title, Paragraph } = Typography;

const SubscribeButton = () => {
    const [form, setForm] = useState({
        first_name: '',
        last_name: '',
        email: ''
    });

    const handleChange = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = async () => {
        if (!form.first_name || !form.last_name || !form.email) {
            Swal.fire('Missing Info', 'Please fill in all fields.', 'warning');
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(form.email)) {
            Swal.fire('Invalid Email', 'Please enter a valid email address.', 'error');
            return;
        }

        try {
            const res = await axios.post('https://hercupoverflows.in/add_user.php', {
                first_name: form.first_name,
                last_name: form.last_name,
                email: form.email
            });

            if (res.data.status === 'success') {
                Swal.fire('Subscribed!', res.data.message, 'success');
                setForm({ first_name: '', last_name: '', email: '' });
            } else {
                Swal.fire('Oops!', res.data.message || 'Subscription failed', 'error');
            }
        } catch (error) {
            console.error('Error:', error);
            Swal.fire('Server Error', 'Could not connect to the server.', 'error');
        }
    };


    return (
        <div className="subs-container">
            <div className="heading-container">
                <Title level={2} className="subscribe-title">
                    Thanks for visiting our page!
                </Title>
                <Paragraph className="subscribe-subtitle">
                    Subscribe for more information and exclusive updates
                </Paragraph>
            </div>

            <div className="input-group">
                <Input
                    size="large"
                    placeholder="First Name"
                    prefix={<UserOutlined />}
                    className="input-field"
                    value={form.first_name}
                    onChange={(e) => handleChange('first_name', e.target.value)}
                />
                <Input
                    size="large"
                    placeholder="Last Name"
                    prefix={<UserOutlined />}
                    className="input-field"
                    value={form.last_name}
                    onChange={(e) => handleChange('last_name', e.target.value)}
                />
                <Input
                    size="large"
                    placeholder="Email Address"
                    prefix={<MailOutlined />}
                    className="input-field"
                    value={form.email}
                    onChange={(e) => handleChange('email', e.target.value)}
                />
            </div>
            <Button
                type="primary"
                size="large"
                className="submit-button"
                onClick={handleSubmit}
                style={{ marginBottom: '20px' }}
            >
                YES, I'M IN!
            </Button>
        </div>
    );
};

export default SubscribeButton;
